<template>
    <div class="popup" v-if="is_answerPopup">
        <div class="popup_div">
            <i class="esc" @click.stop="shutDown"><img src="@/assets/img/shutDown.png" alt=""></i>
          <div class="answer_title">
           <span v-if="is_answer">问卷：</span><span v-else>答案：</span> {{title}}
          </div>
          <div class="answer_ul">
            <div class="answer_li flex_between" @click="answerFunT(liem.id)" 
            v-for="(liem,index) in options_arr" :key="index">
                <i class="options" v-if="question.type == 1" :class="{'selected':options_id == liem.id}"></i>
                <div class="options_text">
                    {{liem.text}}
                </div>
                <span class="percentage" v-show="!is_answer">{{answer_arr[index]}}</span>
            </div>
          </div>
          <button class="submit flex_center" v-if="is_answer" @click.stop="submit">提交</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'popup',
        data() {
            return {
                options_arr:[
                    {text: 'A.这是打哪安安安',id:1,percentage:'10%'},
                    {text: 'B.这是打哪安安安',id:2,percentage:'10%'},
                    {text: 'C.这是打哪安安安',id:3,percentage:'10%'},
                ],
                title:'这是标题',//问题
                correct:'',//正确答案
                time:0,//展示时间

                timeSet:null,//倒计时计时器

                is_answer:true,//是否答题
                answer_arr:[],//答案内容
            }
        },
        props: {
            is_answerPopup:{
                type:Boolean,
                default:false
            },
            question:{//答题
                type:Object,
            },
            options_id:{
                type:Number
            }
        },
        watch:{
            options_id:function(eve,set){
                if(!this.is_answer){
                    this.options_id = set;
                }
            },
            is_answerPopup:function(eve){
                let that = this;
                if(eve == true){
                    this.getAnswer();
                    this.$nextTick(()=>{
                        that.mobileFun();
                    })
                }
            }
        },
        methods: {
            answerFunT(id){//答题
                if(this.question.type !== 2){
                    this.$emit('answerFun',id);
                } 
            },
            mobileFun(){
                if(this._isMobile()){
                    $('.popup').addClass('mobile')
                }
            },
            getAnswer(){//分配题
                let arr = [];
                this.question.select.forEach((element,index) => {
                    arr.push({
                        text: element,
                        id:index+1,
                    })
                });
                this.options_arr = arr;
                let arrT = [];
                for(let key in this.question.percent){
                    arrT.push(this.question.percent[key].substring(2))
                }
                this.answer_arr = arrT;
                this.is_answer = this.question.type == 1?true:false;
              
                this.title = this.question.title;
                this.correct = this.question.answer;
                this.time = this.question.time;
                let that = this;
                this.timeSet = setInterval(()=>{
                    if(that.time <= 0){
                        that.shutDown();
                    }else{
                        that.time -- ;
                    }
                },1000)
            },
            submit(){//提交问答
              if(!this.options_id || this.options_id<=0){
                layer.open({
                    content: "请选择答案!",
                    time: true,
                    skin: "msg"
                });
                  return false;
              }
              let center = this.options_arr[this.options_id-1].text;
              let data = {
                member_id:this.question.userId,
                question_id:this.question.question_id,
                // result:center.indexOf(this.correct) != -1?1:2,
                question:center.substring(0,1),
              }
              let that = this;
              this.$post("answer",data).then(e => {
                // if(center.indexOf(this.correct) != -1){
                //     layer.open({
                //         content: "答题正确!",
                //         time: true,
                //         skin: "msg"
                //     });
                // }else{
                //     layer.open({
                //         content: "答题错误，正确答案："+that.correct,
                //         time: true,
                //         skin: "msg"
                //     });
                // }
                // that.shutDown();
                // let arr = [];
                // for(let key in e.data){
                //     arr.push(e.data[key].substring(2))
                // }
                //  
                // that.answer_arr = arr;
                // that.is_answer = false;
                this.shutDown();
               })

               
            },
            shutDown(){//关闭弹窗
                clearInterval(this.timeSet);
                this.$emit('popupFun');
            }

        },
        mounted() {
            this.mobileFun();
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .popup{
        position: fixed;
        top:0;left:0;right: 0;bottom: 0;
        background: rgba(0,0,0,.4);
        z-index: 999;
    }
    .popup .popup_div{
        position: absolute;
        top:50%;
        min-width: 577px;
        max-width: 700px;
        left: 50%;
        transform: translate(-50%,-50%);
        background: #fff;
        border-radius: 20px;
        box-shadow: 0 0 35px rgba(0,0,0,.16);
        padding: 40px 40px 40px 56px;
    }
    .popup .popup_div .esc{
        position: absolute;
        right: 10px;top:10px;
        cursor: pointer;
        width: 26px;height: 26px;
    }
    .answer_title{
        font-size: 28px;
        color:#F24D5B;
    }
    .answer_ul{
        margin-top: 50px;
    }
    .answer_ul .answer_li{
        margin-bottom: 30px;
        align-items: flex-start;
        cursor: pointer;
    }
    .answer_li .options{
        width: 25px;
        height: 25px;
        border-radius: 50%;
        border:2px solid #F24D5B;
        transform: translateY(4px);
        position: relative;
    }
    .answer_li .options.selected::after{
        content: '';
        width:11px;
        height: 11px;
        border-radius: 50%;
        background: #F24D5B;
        position: absolute;
        top:50%;left:50%;
        transform: translate(-50%,-50%);
    }
    .answer_li .options_text{
        flex: 1;
        margin-left: 17px;
        font-size: 22px;
        margin-right: 15px;
        color:#333;
    }
    .answer_ul .answer_li .percentage{
        font-size:28px;
        color:#579BE2;
        line-height: 1em;
    }
    .submit{
        width: 60%;
        height: 56px;
        border-radius: 28px;
        color:#fff;
        font-size: 28px;
        margin: 50px auto 0 auto;
        background-image: linear-gradient(90deg,#F54050,#EC3141);
    }
    /* 手机端 */
    .popup.mobile .popup_div{
        max-width: 80%;
        min-width: 70%;
        width: 75%;
        border-radius: 1rem;
        padding: 2.1rem 1.8rem 2rem 2.6rem;
    }
    .popup.mobile .popup_div .esc{
        width: 1.8rem;
        height: auto;
        top:1rem;right: 1rem;
    }
    .popup.mobile .popup_div .answer_title{
        font-size: 1.4rem;
    }
    .popup.mobile .popup_div .options_text{
        font-size: 1.1rem;
        color:#333;
    }
    .popup.mobile .popup_div .options{
        width: 1.5rem;
        height: 1.5rem;
        transform: translateY(.1rem);
        border-width: .1rem;
    }
    .popup.mobile .popup_div .answer_ul{
        margin-top:2.3rem;
    }
    .popup.mobile .popup_div .answer_ul .answer_li{
        margin-bottom: 1.5rem;
    }
    .popup.mobile .popup_div .options.selected::after{
        width: .8rem;
        height: .8rem;
    }
    .popup.mobile .popup_div .submit{
        width: 100%;
        height: 4rem;
        font-size: 1.8rem;
        margin-top:2rem;
    }
    .popup.mobile .answer_ul .answer_li .percentage{
        font-size:1.4rem;
        color:#579BE2;
        line-height: 1em;
    }
</style>


// WEBPACK FOOTER //
// src/components/assembly/AnswerPopup.vue